import { HttpErrorResponse } from '@angular/common/http';
import { GetTranslationsDto, UpdateTranslationsDto } from '@modeso/types__aumico-lib-notes-be';
import { createAction, props } from '@ngrx/store';

export const getTranslations = createAction(
    '[Aumico-Notes] getTranslations',
    props<{ locales: string[]; untranslatedOnly: boolean }>(),
);
export const onGetTranslationsSuccess = createAction(
    '[Aumico-Notes] onGetTranslationsSuccess',
    props<{ payload: GetTranslationsDto }>(),
);
export const onGetTranslationsFailed = createAction(
    '[Aumico-Notes] onGetTranslationsFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const updateTranslations = createAction(
    '[Aumico-Notes] updateTranslations',
    props<{ payload: UpdateTranslationsDto }>(),
);
export const onUpdateTranslationsSuccess = createAction('[Aumico-Notes] onUpdateTranslationsSuccess');
export const onUpdateTranslationsFailed = createAction(
    '[Aumico-Notes] onUpdateTranslationsFailed',
    props<{ payload: HttpErrorResponse }>(),
);
